export default __webpack_public_path__ + "static/media/daf49ce87fd868b5a2b1efc46cb56511.svg";